import { useMemo } from 'react';

import { useMemberId } from '@trello/authentication';
import { Entitlements } from '@trello/entitlements';

import { useGaPaidUserFragment } from './GaPaidUserFragment.generated';

export const useIsPaidUser = ({ skip }: { skip?: boolean } = {}): boolean => {
  const memberId = useMemberId();
  const { data } = useGaPaidUserFragment({
    from: { id: memberId },
  });

  const isPaidUser = useMemo(
    () =>
      (data?.organizations ?? []).some((organization) => {
        const offering = organization?.offering || '';
        const isStandard = Entitlements.isStandard(offering);
        const isPremium = Entitlements.isPremium(offering);
        const isEnterprise = Entitlements.isEnterprise(offering);
        return isStandard || isPremium || isEnterprise;
      }),
    [data],
  );

  return isPaidUser;
};
